import React, { lazy, Suspense } from 'react';
import { StyleSheetManager } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import { AuthProviderBoffice } from './contents/router/Auth/BofficeAuthContext.js';

const BofficeRouter = lazy(() => import('./contents/router/BofficeRouter'));
const shouldForwardProp = (prop) => prop !== 'sortActive';

function App() {
    return (
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
            <Suspense>
                <AuthProviderBoffice>
                    <BofficeRouter />
                </AuthProviderBoffice>
            </Suspense>
        </StyleSheetManager>
    );
}

export default App;
